import Icon from '../components/Icon.vue'

Icon.register({"digg":{"width":2048,"height":1792,"paths":[{"d":"M328 282h204v983h-532v-697h328v-286zM328 1101v-369h-123v369h123zM614 568v697h205v-697h-205zM614 282v204h205v-204h-205zM901 568h533v942h-533v-163h328v-82h-328v-697zM1229 1101v-369h-123v369h123zM1516 568h532v942h-532v-163h327v-82h-327v-697zM1843 1101v-369h-123v369h123z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/digg.js
// module id = 230
// module chunks = 0